<template>
    <div id="account-nationality">
      <f7-list form class="form-group">
        <f7-list-input
            input-id     ="nationality"
            id           ="nationalityInput"
            name         ="nationality"
            class        ="clickable-row use-chevron"

            :label       ="$t('regis-nationality')"
            :placeholder ="$t('regis-nationality')"
            :value       ="updateDetails.nationalityId > 0 ? updateDetails.nationality : ''"
            outline
            floating-label
        >
            <f7-link popover-open=".nationality-dropdown-1" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>

        <f7-popover id="dropdownNationality" class="nationality-dropdown-1 dropdown-default dropdown account" :backdrop="true">
          <f7-list>
              <f7-list-item v-for="country in countryList" :key="country.countryId" popover-close link="#" @click="selectNationality(country.countryId);validateInput({id: 'nationality'});validateNextButton()" class="">
                {{ country.countryName }}
              </f7-list-item>
          </f7-list>
        </f7-popover>

    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      countryList: Array
    },
    mounted (){
      this.init();
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('customer', [
          'updateDetails'
      ])
    },
    methods: {
      ...mapActions('customer', [
          'setUpdateNationality',
          'validateInput',
      ]),

      async init(){
          const self    = this;
          const popover = ".account.nationality-dropdown-1";
          const popoverInner = ".account.nationality-dropdown-1 .popover-inner";
          const popoverId = "dropdownNationality";
          const inputId = "nationality";
          const inputListId = "#nationalityInput";
          await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
      },

      selectNationality(countryId) {
        const self            = this;
        const countryList     = self.countryList;

        Object.keys(countryList).forEach(key => {
            if(countryList[key].countryId == countryId) {
                self.setUpdateNationality({id: countryList[key].countryId, name: countryList[key].countryName});
                return;
            }
        })

      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>